import React from "react";

import HWLogoIcon from "../../assets/images/HWLogoIcon";
import LogoGrocerBarSvg from "../../assets/images/LogoGrocerBar.svg";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { IStallMode } from "../../contexts/ConfigContext/types";
import Condition from "../Conditional/Condition";
import FlintLogo from "../Logo/FlintLogo";
import { Image } from "../elements";
import "./StallInfo.scss";

const StallInfo: React.FC = () => {
	const { state: stallMode } = useConfigContext((state) => state.stallMode);
	const { state: stall } = useConfigContext((state) => state.config.stall);

	return (
		<div className="CompanySection">
			<Condition check={stallMode === IStallMode.FAIRPRICE}>
				<div className="CompanyLogo">
					<Image src={LogoGrocerBarSvg} alt="Grocer Bar Logo" className="Logo" />
					<div className="CompanyName">
						<div className="CompanyNamePrimary" />
						<div className="CompanyNameSecondary" />
					</div>
				</div>
				<div className="CompanyAddress">
					<div className="CompanyAddressTitle">Punggol Digital District Finest</div>
					<div className="CompanyAddressDetail">Punggol Coast Mall Tower 98</div>
					<div className="CompanyAddressPhone" />
					<div className="CompanyAddressDetail">
						98 Punggol Way #01-217 and #02-217, Singapore 829857
					</div>
				</div>
			</Condition>
			<Condition check={stallMode === IStallMode.WANG}>
				<div className="CompanyLogo">
					<HWLogoIcon />
					<div className="CompanyName">
						<div className="CompanyNamePrimary" />
						<div className="CompanyNameSecondary" />
					</div>
				</div>
				<div className="CompanyAddress">
					{stall.address?.map((address) => (
						<div key={address} className="CompanyAddressDetail">
							{address}
						</div>
					))}
				</div>
			</Condition>
			<Condition check={stallMode === IStallMode.FLINT}>
				<div className="CompanyLogo">
					<FlintLogo />
					<div className="CompanyName">
						<div className="CompanyNamePrimary" />
						<div className="CompanyNameSecondary" />
					</div>
				</div>
				<div className="CompanyAddress">
					<div className="CompanyAddressTitle" />
					{stall.address?.map((address) => (
						<div key={address} className="CompanyAddressDetail">
							{address}
						</div>
					))}
				</div>
			</Condition>
		</div>
	);
};

export default StallInfo;
